module.exports = __webpack_public_path__ + "static/media/jivoChat.3ddefe3d.svg";